import React from "react";
import styled from "styled-components";
import { FiPlus } from "react-icons/fi";

interface UploadButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const Button = styled.button<{ disabled?: boolean }>`
  --width: 120px;
  --height: 30px;
  min-width: var(--width);
  height: var(--height);
  background: ${({ disabled }) =>
    disabled ? "rgba(37, 99, 235, 0.5)" : "rgb(37, 99, 235)"};
  /* 🔵 updated to blue-600 color: rgb(37, 99, 235) */
  position: relative;
  text-align: center;
  border-radius: 6px;
  font-family: "Arial", sans-serif;
  font-size: 13px;
  transition: background 0.3s;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  color: white;
  border: none;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    height: 42px;
    border-radius: 10px;
    font-size: 14px;
  }

  &:hover {
    .Text {
      top: -100%;
    }

    .Icon {
      top: 0;
    }
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  color: #fff;
  overflow: hidden;
`;

const Text = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: top 0.4s ease;
`;

const Icon = styled.span`
  position: absolute;
  top: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: top 0.4s ease;

  svg {
    width: 18px;
    height: 18px;
  }
`;

const UploadButton: React.FC<UploadButtonProps> = ({ onClick, disabled }) => {
  return (
    <Button onClick={onClick} disabled={disabled}>
      <ButtonWrapper>
        <Text className="Text">Add Inventory</Text>
        <Icon className="Icon">
          <FiPlus />
        </Icon>
      </ButtonWrapper>
    </Button>
  );
};

export default UploadButton;
